import { writable } from 'svelte/store';
export const storeEvents = writable([]);
export const storeEventsError = writable("");
